import React from "react";

import { Skeleton } from "@mui/material";

import DocTitle from "@utils/DocTitle";
import { cn } from "@utils/tailwind";

import BackButton from "./BackButton";
import { Type } from "./Type";

const PageTitle: React.FC<
  {
    fallbackUrl?: string | boolean;
    title: string;
    /** Sets document title from `title`, but shows a skeleton in the view. */
    loading?: boolean;
  } & React.HTMLAttributes<HTMLDivElement>
> = ({ fallbackUrl, title, loading, children, className, ...props }) => {
  return (
    <>
      <DocTitle title={title} />
      <div {...props} className={cn("flex gap-2 items-center", className)}>
        {fallbackUrl && (
          <BackButton
            defaultUrl={typeof fallbackUrl === "string" ? fallbackUrl : "/"}
          />
        )}
        {loading ? (
          <Skeleton variant="text" width={200} height={36} />
        ) : (
          <Type.H1 className="m-0 font-medium">{title}</Type.H1>
        )}
        {children}
      </div>
    </>
  );
};

export default PageTitle;
